const def = {
  // fn: ['url', 'post', 'dataType']
  // 多使用空行或者注释来归类
  login: ['meet/index.php?r=act/login', 'post', 'qs'],
  codeLogin: ['meet/index.php?r=act/checkCode', 'post', 'qs'],
  blockContent: ['meet/index.php?r=act/index', 'post', 'qs'],
  userCount: ['meet/index.php?r=act/getUserCount', 'post', 'qs'],
  loopPrize: ['meet/index.php?r=act/loopPrizeData', 'post', 'qs'],
  lotteryList: ['meet/index.php?r=act/getLotteryDataList', 'post', 'qs'],
  userLotteryCount: ['meet/index.php?r=act/getUserLotteryCount', 'post', 'qs'],
  dayLottery: ['meet/index.php?r=act/dayLottery', 'post', 'qs'],
  prizeList: ['meet/index.php?r=act/getUserPrize', 'post', 'qs'],
  actStatus: ['meet/index.php?r=act/getActStatus', 'post', 'qs'],
  addShareCount: ['meet/index.php?r=act/addShareCount', 'post', 'qs'],
  statItemClick: ['meet/index.php?r=act/statItemClick', 'post', 'qs'],
};

export default def;



// WEBPACK FOOTER //
// ./src/api/api.def.js